import React from 'react';
import PropTypes from 'prop-types';

class Optawidget extends React.Component {
  componentDidMount() {
    window.opta_settings = {
      subscription_id: '98c752914713d2be0ee441bc511adf17',
      language: 'en_GB',
      timezone: 'user',
      load_when_visible: false,
    };
    const optaScript = document.getElementById('optaJs');
    if (!optaScript) {
      const script = document.createElement('script');
      script.src = 'https://secure.widget.cloud.opta.net/v3/v3.opta-widgets.js';
      script.async = true;
      script.id = 'optaJs';
      document.body.appendChild(script);
    }
    const optaLink = document.getElementById('optaCss');
    if (!optaLink) {
      const link = document.createElement('link');
      link.href =
        'https://secure.widget.cloud.opta.net/v3/css/v3-mobile.cricket.opta-widgets.css';
      link.rel = 'stylesheet';
      link.id = 'optaCss';
      document.body.appendChild(link);
    }
  }

  render() {
    let widgetHtml = '';
    switch (this.props.widgetName) {
      case 'match_action':
        widgetHtml = (
          <opta-widget
            widget="match_action"
            competition={this.props.competition}
            season={this.props.season}
            match={this.props.match}
            template="normal"
            show_innings_breakdown="true"
            show_crests="true"
            team_naming="full"
            player_naming="full"
            show_live="true"
            show_logo="true"
            show_title="true"
            breakpoints="400"
            sport="cricket"
            load={this.props.autoload}
          />
        );
        break;

      case 'manhattan':
        widgetHtml = (
          <opta-widget
            widget="manhattan"
            competition={this.props.competition}
            season={this.props.season}
            match={this.props.match}
            template="normal"
            live="true"
            show_match_header="true"
            show_crests="true"
            show_competition_name="true"
            show_state_of_play="true"
            show_graphs="all"
            side="both"
            show_key="true"
            show_innings="both"
            show_tooltips="true"
            show_officials="on_field"
            show_axis_labels="true"
            show_timecontrols="true"
            team_naming="full"
            player_naming="full"
            show_live="true"
            show_logo="true"
            show_title="true"
            breakpoints="400, 700"
            sport="cricket"
            load={this.props.autoload}
          />
        );
        break;

      case 'wagonwheel':
        widgetHtml = (
          <opta-widget
            widget="wagonwheel"
            competition={this.props.competition}
            season={this.props.season}
            match={this.props.match}
            template="normal"
            live="true"
            show_match_header="true"
            show_crests="true"
            show_state_of_play="true"
            show_team_sheets="true"
            show_innings="all"
            side="both"
            show_key="true"
            show_runs_summary="true"
            show_segments="true"
            show_tooltips="true"
            team_naming="full"
            player_naming="full"
            show_logo="true"
            show_live="true"
            show_title="true"
            breakpoints="400, 700"
            sport="cricket"
            load={this.props.autoload}
          />
        );
        break;

      default: {
        widgetHtml = (
          <opta-widget
            widget="competition_stats"
            competition={this.props.competition}
            season={this.props.season}
            template="normal"
            show_crests="true"
            show_images="true"
            show_ranks="true"
            show_player_rankings="true"
            show_team_rankings="true"
            visible_stats="total_games,total_runs,highest_score,total_hundreds,total_fifties,strike_rate,total_sixes,total_wickets_taken"
            limit="5"
            team_naming="full"
            player_naming="full"
            show_logo="true"
            show_title="true"
            breakpoints="400"
            sport="cricket"
            load={this.props.autoload}
          />
        );
      }
    }
    return widgetHtml;
  }
}

Optawidget.propTypes = {
  widgetName: PropTypes.string,
  competition: PropTypes.string,
  season: PropTypes.string,
  match: PropTypes.string,
  autoload: PropTypes.bool,
};

Optawidget.defaultProps = {
  widgetName: 'competition_stats',
  competition: '0',
  season: '0',
  match: '0',
  autoload: false,
};

export default Optawidget;
